<template>
  <div id="background-task-manager" class="flex justify-between">
    <div id="sidebar">
      <task-manager-sidebar />
    </div>
    <div id="content" class="no-scroll-content">
      <div>
        <!-- sidebar -->
        <vs-sidebar
          class="items-no-padding"
          parent="#background-task-manager"
          :click-not-close="false"
          :hidden-background="true"
          v-model="isDetailSidebarActive"
          position-right
        >
          <task-manager-detail-view />
        </vs-sidebar>
        <div id="searchbar">
          <task-manager-search-bar />
        </div>
        <div id="content-body">
          <task-manager-list />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TaskManagerList from "./TaskManagerList"
import TaskManagerSearchBar from "./TaskManagerSearchBar"
import TaskManagerSidebar from "./TaskManagerSidebar"
import TaskManagerDetailView from "./TaskManagerDetailView"
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";

const { mapMutations, mapState } = createNamespacedHelpers("enterpriseBackgroundTaskManager");


export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  components: {
    TaskManagerList,
    TaskManagerSearchBar,
    TaskManagerSidebar,
    TaskManagerDetailView
  },
  computed: {
    ...mapState(["menuSidebarActive", "detailSidebarActive"]),

    isDetailSidebarActive(){
      return this.detailSidebarActive;
    },

    windowWidth () {
      return this.$store.state.windowWidth;
    },

  },
  methods: {
    ...mapMutations([
      "RESET_ALL_STATE",
       "SET_DETAIL_SIDEBAR_ACTIVE",
       "SET_FILTER_NAME",
       "SET_FILTER_STATUS",
       "SET_FILTER_CATEGORY"
      ]),
    cleanUp () {
      this.RESET_ALL_STATE();
    },

    setParamsName () {
      if (this.$route.params.name) {
        this.SET_FILTER_NAME(this.$route.params.name);
      }
    },
    setParamsStatus () {
      if (this.$route.params.status) {
        this.SET_FILTER_STATUS(this.$route.params.status);
      }
    },
    setParamsType () {
      if (this.$route.params.type) {
        this.SET_FILTER_CATEGORY(this.$route.params.type);
      }
    },
  },
  mounted () {
    this.setParamsName();
    this.setParamsStatus();
    this.setParamsType();
  },
  destroyed () {
    this.cleanUp();
  }
}
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#background-task-manager {
  .vs-sidebar {
    max-width: 360px;
  }

  background-color: $aisea-pure-white;
  border-radius: 4px;
  height: calc(100vh - 120px);

  #sidebar {
    border-right: solid $aisea-light-gray 1px;
  }

  #content {
    width: 100%;

    #searchbar {
      border-bottom: solid $aisea-light-gray 1px;
    }
  }
}
</style>